/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

interface IAnalyticsResultFormatterMessageInput {
  raw: any;
  template: any;
}

export class AnalyticsResultFormatterMessage {
  raw: any;
  template: any;
  constructor({ raw, template }: IAnalyticsResultFormatterMessageInput) {
    this.raw = raw;
    this.template = template;
  }
}
